<!--
<div *ngIf="isAdmin" class="info-row">
  <button
    pButton
    id="hap-button"
    label="Upload History and Physical"
    (click)="openUploadPatientHistoryDialog()"
    aria-label="Upload History and Physical"
    icon="pi pi-upload"
    iconPos="right"
  ></button>
</div>
-->
<p-accordion value="0">
  <p-accordion-panel value="0">
    <p-accordion-header>
      Patient Info (Chief Informant, Chief Complaint, etc.)
    </p-accordion-header>
    <p-accordion-content>
      <div class="info-row">
        <div class="info-col">
          <p><b>CHIEF INFORMANT: </b>{{ patient.getChiefInformant() }}</p>
          <p><b>CHIEF COMPLAINT: </b>{{ patient.getChiefComplaint() }}</p>
          <p><b>HISTORY OF CURRENT PROBLEM: </b>{{ patient.getHistOfCurrProb() }}</p>
        </div>

        <div class="info-col">
          <p><b>ALLERGIES: </b>{{ patient.getAllergies() }}</p>
          <p><b>FAMILY HISTORY: </b>{{ patient.getFamilyHistory() }}</p>
          <p><b>SOCIAL HISTORY: </b>{{ patient.getSocialHistory() }}</p>
        </div>
      </div>
    </p-accordion-content>
  </p-accordion-panel>

  <p-accordion-panel value="1">
    <p-accordion-header>
      Past Medical History (Previous Illnesses, Injuries, Trauma, etc.)
    </p-accordion-header>
    <p-accordion-content>
      <div class="info-row">
        <div class="info-col">
          <p><b>PREVIOUS ILLNESSES: </b>{{ patient.getPreviousIllness() }}</p>
          <p><b>INJURIES OR TRAUMA: </b>{{ patient.getInjuries() }}</p>
          <p><b>DIETARY HISTORY: </b>{{ patient.getDietHistory() }}</p>
          <p><b>CURRENT MEDICATIONS: </b>{{ patient.getCurrentMeds() }}</p>
        </div>
        <div class="info-col">
          <p><b>CONTAGIOUS DISEASES: </b>{{ patient.getContagiousDiseases() }}</p>
          <p><b>SURGICAL HISTORY: </b>{{ patient.getSurgicalHistory() }}</p>
          <p><b>OTHER: </b>{{ patient.getOtherPastMedHist() }}</p>
        </div>
      </div>
    </p-accordion-content>
  </p-accordion-panel>

  <p-accordion-panel value="2">
    <p-accordion-header>
      Review of Systems (Integument, Cardiovascular, Gastrointestinal, etc.)
    </p-accordion-header>
    <p-accordion-content>
      <div class="info-row">
        <div class="info-col">
          <p><b>H.E.E.N.T.: </b>{{ patient.getHEENT() }}</p>
          <p><b>LYMPHATIC: </b>{{ patient.getLymphatic() }}</p>
          <p><b>INTEGUMENT: </b>{{ patient.getIntegument() }}</p>
          <p><b>RESPIRATORY: </b>{{ patient.getRespiratory() }}</p>
          <p><b>CARDIOVASCULAR: </b>{{ patient.getCardiovascular() }}</p>
          <p><b>MUSCULOSKELETAL: </b>{{ patient.getMusculoskeletal() }}</p>
        </div>
        <div class="info-col">
          <p><b>GASTROINTESTINAL: </b>{{ patient.getGastrointestinal() }}</p>
          <p><b>DEVELOPMENTAL: </b>{{ patient.getDevelopmental() }}</p>
          <p><b>NEUROLOGIC: </b>{{ patient.getNeurologic() }}</p>
          <p><b>ENDOCRINE: </b>{{ patient.getEndocrine() }}</p>
          <p><b>GENITOURINARY (G/U): </b>{{ patient.getGenitoUrinary() }}</p>
        </div>
      </div>
    </p-accordion-content>
  </p-accordion-panel>

  <p-accordion-panel value="3">
    <p-accordion-header>
      Physical Examination (General, Vital Signs, Integument, etc.)
    </p-accordion-header>
    <p-accordion-content>
      <!-- TODO: PHYSICAL EXAM SECTION IS STILL A WIP. NEED TO WORK ON FIREBASE TOO -->
      <div class="info-row">
        <div class="info-col">
          <p><b>GENERAL: </b>{{ patient.getPEGeneral() }}</p>
          <p><b>VITAL SIGNS: </b>{{ patient.getPEVitalSigns() }}</p>
          <p><b>SKIN: </b>{{ patient.getPESkin() }}</p>
          <p><b>H.E.E.N.T.: </b>{{ patient.getPEHEENT() }}</p>
          <p><b>CARDIOVASCULAR: </b>{{ patient.getPECardio() }}</p>
          <p><b>RESPIRATORY </b>{{ patient.getPERespiratory() }}</p>
          <p><b>GASTROINTESTINAL: </b>{{ patient.getPEGastrointestinal() }}</p>
        </div>
        <div class="info-col">
          <p><b>GENITOURINARY: </b>{{ patient.getPEGenitourinary() }}</p>
          <p><b>MUSCULOSKELETAL: </b>{{ patient.getPEMusculoskeletal() }}</p>
          <p><b>NEUROLOGIC: </b>{{ patient.getPENeurologic() }}</p>
          <p><b>DEVELOPMENTAL: </b>{{ patient.getPEDevelopmental() }}</p>
          <p><b>ENDOCRINE: </b>{{ patient.getPEEndocrine() }}</p>
          <p><b>LYMPHATIC: </b>{{ patient.getPELymphatic() }}</p>
        </div>
      </div>
    </p-accordion-content>
  </p-accordion-panel>

  <p-accordion-panel value="4">
    <p-accordion-header>
      Impressions (Plan, Provider Signature, Day)
    </p-accordion-header>
    <p-accordion-content>
      <div class="info-row">
        <div class="info-col">
          <p><b>IMPRESSIONS: </b>{{ patient.getImpressions() }}</p>
          <p><b>PLAN: </b>{{ patient.getPlan() }}</p>
          <p><b>PROVIDER SIGNATURE: </b>{{ patient.getProvSignature() }}</p>
          <p><b>DAY: </b>{{ patient.getImpressionsDay() }}</p>
        </div>
      </div>
    </p-accordion-content>
  </p-accordion-panel>
</p-accordion>